import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogHeader","RelatedPosts"] */ "/opt/build/repo/src/app/blog/[slug]/components.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/opt/build/repo/src/components/ui/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Shimmer"] */ "/opt/build/repo/src/components/ui/shimmer.tsx");
